export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.accessToken) {
    // return { Authorization: 'Bearer ' + user.accessToken }; // para back-end com Authorization "Bearer"
    let time = Date.now() - user.time;
    if(time > 43200000) localStorage.removeItem("user"); // remove do LocalStorage após 12 horas

    return { 'x-access-token': user.accessToken, 'username':  user.username};       // para back-end Node.js Expres
  } else {
    return {};
  }
}